<template>
  <div :style="styleContainer">
    <v-fade-transition leave-absolute>
      <div class="smiles_loading" v-show="loading">
        <v-row align="center" justify="center" class="fill-height">
          <v-col>
            <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="image"
              ></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
    </v-fade-transition>
    <div class="svg-container">
      <svg style="display: none">
        <defs>
          <linearGradient id="marker">
            <stop stop-color="#2f2" offset="20%"></stop>
            <stop stop-color="#2f2" offset="100%"></stop>
          </linearGradient>
        </defs>
      </svg>
      <svg
        :id="svgId"
        class="svgback"
        :style="styleSvg"
        :viewbox="`0 0 ${width} ${height}`"
        xmlns="http://www.w3.org/2000/svg"
      ></svg>
    </div>
  </div>
</template>

<script>
import SmilesDrawer from 'smiles-drawer';

export default {
  name: 'SmilesDrawer',
  props: {
    id: {
      type: String
    },
    smiles: {
      type: String
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 300
    },
    highlight: {
      type: Array
    }
  },
  data() {
    return {
      loading: true,
      delayHandler: null,
      validSmiles: false,
      updating: false,
      svgns: 'http://www.w3.org/2000/svg'
    };
  },
  watch: {
    smiles() {
      this.delayUpdate();
    },
    highlight() {
      this.delayUpdate();
    }
  },
  computed: {
    svgId() {
      return this.id || `SMILES_${(this.smiles || '').hashCode()}`;
    },
    styleContainer() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        margin: 'auto',
        position: 'relative'
      };
    },
    styleSvg() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`
      };
    },
    options() {
      return {
        debug: false,
        width: this.width,
        height: this.height,
        compactDrawing: false
      };
    },
    svgDrawer() {
      return new SmilesDrawer.SvgDrawer(this.options);
    }
  },
  methods: {
    delayUpdate() {
      this.loading = true;
      if (this.smiles != undefined) {
        this.updating = true;
        if (this.delayHandler) clearTimeout(this.delayHandler);
        this.delayHandler = setTimeout(() => this.update(), 10);
      }
    },
    update() {
      SmilesDrawer.parse(
        this.smiles,
        tree => {
          this.svgDrawer.draw(tree, this.svgId, 'light', false);
          this.updating = false;
          this.validSmiles = true;
          this.$emit('validate', true);
        },
        err => {
          console.log(err);
          this.updating = false;
          this.validSmiles = false;
          this.$emit('validate', false);
        }
      );
      this.markerInit();
      this.loading = false;
    },
    markerInit() {
      document
        .querySelectorAll('.mark-circle')
        .forEach(e => e.parentNode.removeChild(e));

      let index = 0;
      let lines = document.querySelectorAll('.svgback text.debug');
      for (let i = 0, l = lines.length; i < l; i++) {
        let x = lines[i].getAttribute('x');
        let y = lines[i].getAttribute('y');
        let circleStr = `<circle id="mark-el${index}" class="mark-circle" cx="${x}" cy="${y}" r="10"/>`;
        document
          .querySelector('#' + this.svgId + ' g:nth-of-type(1)')
          .insertAdjacentHTML('beforebegin', circleStr);
        index++;
      }
    },
    markerUpdate(tab) {
      if (tab == 0) {
        let el = document.querySelectorAll('.mark-light');
        for (let i = 0, l = el.length; i < l; i++) {
          el[i].setAttribute('class', 'mark-circle');
        }
      } else {
        let el = document.querySelectorAll('.mark-light');
        for (let i = 0, l = el.length; i < l; i++) {
          el[i].setAttribute('class', 'mark-circle mark-show');
        }
      }
    },
    markerShow(arr) {
      let el = document.querySelectorAll('.mark-show');
      for (let i = 0, l = el.length; i < l; i++) {
        el[i].classList.remove('mark-show');
      }
      for (let i = 0, l = arr.length; i < l; i++) {
        if (document.querySelectorAll('#mark-el' + arr[i])[0])
          document
            .querySelectorAll('#mark-el' + arr[i])[0]
            .setAttribute('class', 'mark-circle mark-show');
      }
    },
    markerEl(index, tab) {
      this.markerUpdate(tab);
      document
        .querySelectorAll('#mark-el' + index)[0]
        .setAttribute('class', 'mark-circle mark-light');
    }
  },
  mounted() {
    this.delayUpdate();
  }
};
</script>
